var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('service-toolbar'),_c('forms-tab',{attrs:{"service-id":'id' in _vm.$store.service ? _vm.$store.service.id : false,"customer-id":_vm.$store.service ? _vm.$store.service.customer_id : false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }